module.exports = __webpack_public_path__ + "img/hagerup_Det_ene_diktet1.292c167e.jpg";